import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const FieldNameViewContainer = styled.span`
  color: ${token('color.text.subtlest', '#626F86')};
`;
